import { DataCollectorInstance, TransactionCollector } from '@scfe-common/core';
import { handleResponseData } from '../../utils';
import { ActionType, RequestState } from '@scfe-common/chain-tracker';
import { CustomActionType } from '@/utils/chain-tracker/plugins/types';

export default [
  {
    name: 'SLAMTInboundReceiving',
    status: {
      errorCount: 0,
    },
    scanDeviceTime: 'custom_MTInboundReceiving_scan_device_time',
    scanDeviceErrorCount:
      'custom_MTInboundReceiving_scan_device_time_error_count',
    scanShippingTime: 'custom_MTInboundReceiving_scan_shipping_time',
    scanShippingErrorCount:
      'custom_MTInboundReceiving_scan_shipping_time_error_count',
    scanSKUTime: 'custom_MTInboundReceiving_scan_SKU_time',
    scanSKUErrorCount: 'custom_MTInboundReceiving_scan_SKU_time_error_count',
    collector: {} as TransactionCollector,
    getPointList: function () {
      return [
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#mtInbound-receiving-input-deviceID',
          },
          handler: () => {
            this.collector = DataCollectorInstance.createTransactionCollector();
            this.collector.startTrack({
              name: this.scanDeviceTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/mtreceiving\/scan_device_id(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanDeviceTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanDeviceErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
          },
        },
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#mtInbound-receiving-input-shippingID',
          },
          handler: () => {
            this.collector.startTrack({
              name: this.scanShippingTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/mtreceiving\/scan_sheet_id(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanShippingTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanShippingErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
          },
        },
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#mtInbound-receiving-input-skuID',
          },
          handler: () => {
            this.collector.startTrack({
              name: this.scanSKUTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/mtreceiving\/scan_sku_id(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanSKUTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanSKUErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
            DataCollectorInstance.removeTransactionCollector({
              traceId: this.collector.traceId,
            });
          },
        },
      ];
    },
  },
];
